import { render, staticRenderFns } from "./altong-member.vue?vue&type=template&id=448a1e7c&"
import script from "./altong-member.vue?vue&type=script&lang=js&"
export * from "./altong-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports